import { useState, useEffect } from 'react';

const FORM_URL = 'https://readdy.ai/api/form/d712k2ghb0rqicn689rg';
const STORAGE_KEY = 'spartech_wa_popup_dismissed';

export default function WhatsAppPopup() {
  const [visible, setVisible] = useState(false);
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [hasWA, setHasWA] = useState(true);

  useEffect(() => {
    const dismissed = localStorage.getItem(STORAGE_KEY);
    if (dismissed) return;
    const timer = setTimeout(() => setVisible(true), 8000);
    return () => clearTimeout(timer);
  }, []);

  const dismiss = () => {
    localStorage.setItem(STORAGE_KEY, String(Date.now()));
    setVisible(false);
  };

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setStatus('loading');
    const form = e.currentTarget;
    const data = new URLSearchParams();
    new FormData(form).forEach((v, k) => { if (typeof v === 'string') data.append(k, v); });
    try {
      const res = await fetch(FORM_URL, { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: data.toString() });
      if (!res.ok) throw new Error();
      setStatus('success');
      localStorage.setItem(STORAGE_KEY, String(Date.now()));
    } catch {
      setStatus('error');
    }
  }

  return null;
}
